var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"display-rating"},_vm._l((_vm.maxRating),function(item){return _c('StIcon',{key:item,attrs:{"color":item <= _vm.value ? 'var(--ds-color-chart-16)' : 'var(--ds-color-icon-2)',"icon-name":"star"}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }